module.exports = __webpack_public_path__ + "94484fb770ab62c2fd836442698f54d1.pdf";